import { ApplicationState } from '../reducers';
import type { GenericLocalDecisionTree } from 'ts/types/decision-tree.types';
import {
  DecisionTreeType,
  LocalDecisionTreeState,
  StateType,
} from 'ts/types/decision-tree.types';

export const localDecisionTreeSelector = (
  state: ApplicationState,
): LocalDecisionTreeState => state.localDecisionTree;

export const currentDTSelector = (state: ApplicationState): DecisionTreeType =>
  localDecisionTreeSelector(state).currentDT;

export const currentDecisionTreeSelector = (
  state: ApplicationState,
): GenericLocalDecisionTree => {
  const { diagnosis, services, currentService, currentDT } =
    state.localDecisionTree;
  return currentDT === DecisionTreeType.SERVICE
    ? services[currentService]
    : diagnosis;
};

export const currentGivenAnswerSelector =
  (question: string) =>
  (state: ApplicationState): string =>
    localDecisionTreeSelector(state).lastAnswers[question];

export const currentDTAnswersSelector = (state: ApplicationState): any[] =>
  localDecisionTreeSelector(state).currentPath;

export const currentDTServiceSelector = (state: ApplicationState): string =>
  localDecisionTreeSelector(state).currentService;

export const allDTServiceSelector = (state: ApplicationState): string[] =>
  localDecisionTreeSelector(state).currentServices;

export const currentCheckUpServiceSelector = (
  state: ApplicationState,
): string | undefined => localDecisionTreeSelector(state).currentCheckUpService;

export const diagnosisResultSelector = (state: ApplicationState): any =>
  localDecisionTreeSelector(state).diagnosis.result;

export const diagnosisPathSelector = (state: ApplicationState): any =>
  localDecisionTreeSelector(state).diagnosis.actualPath;

export const interventionObjectsContextSelector = (
  state: ApplicationState,
): StateType[] => localDecisionTreeSelector(state).interventionObjectsContext;
